import { DateTime } from 'luxon';

export function guessDate(val: string): Date | undefined {
    try {
        const date = DateTime.fromFormat(val, 'dd/MM/yyyy');
        if (date.isValid) {
            return date.toJSDate();
        } else {
            return undefined;
        }
    } catch {
        return undefined;
    }
}
